import { mediaQuery } from 'constants/ui';

export const headerStyles = {
  gap: '8px',
  [mediaQuery.mobile]: {
    gap: '4px',
  },
};

export const headerStatusBarStyles = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
};

export const headerStatusSummaryStyles = {
  flexDirection: 'row',
  gap: '10px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  [mediaQuery.mobile]: {
    gap: '6px',
  },
};

export const configurationStackStyles = {
  gap: '2px',
  minWidth: 0,
};

export const configurationTitleRowStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
};

export const configurationSwitcherButtonStyles = {
  padding: '2px',
  color: ({ palette }) => palette.text.dark,
};

export const configurationSkeletonStyles = {
  width: '160px',
  height: '20px',
};

export const configurationModelSkeletonStyles = {
  width: '120px',
  height: '14px',
};

export const headerActionsStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
};

export const headerCloseButtonStyles = {
  width: '24px',
  height: '24px',
  padding: 0,
};
